import React from "react";
import WebsiteNavbar from "../components/WebsiteNavbar";
import FAQ from "../components/FAQ"; // adjust path if FAQ is in components
import WebsiteFooter from "../components/Footer"; // if you have one

const FAQPage = () => {
  return (
    <>
      <WebsiteNavbar />
      <FAQ />
      <WebsiteFooter />
    </>
  );
};

export default FAQPage;